<template>
    <InputNullableTimespan
        :model-value="modelValue"
        :format="format"
        :validator="validator"
        :showNullSetter="showNullSetter"
        :mode="mode"
        :readonly="readonly"
        @change="change"
        @update:model-value="updateModelValue"
    />
</template>
<script lang="ts" setup>
import type { ValidatorDef } from '@/objects/gui';
import type { ITimeSpan } from '@/objects/TimeSpan';
import type { TimeType } from '@/utilities/dateutils';
import InputNullableTimespan from './InputNullableTimespan.vue';

// REMEMBER TO ADD THE SAME TO THE NON-NULLABLE InputTimespan IF YOU CHANGE ANYTHING HERE
const props = withDefaults(
    defineProps<{
        modelValue: ITimeSpan;
        /**
         * The format to use.
         */
        format?: TimeType;

        /**
         * The validator for the input
         * @default null
         */
        validator?: ValidatorDef | null;

        /**
         * If the nullsetter should be shown
         * @default false
         * */
        showNullSetter?: boolean;

        /**
         * The input mode. If we only allow positive or negative values or both
         * @default both
         * TODO: This needs to be implemented when we need it
         */
        mode?: 'positive' | 'negative' | 'both';

        /**
         * If the input is readonly
         * @default false
         */
        readonly?: boolean;
    }>(),
    {
        format: 'TIMEMS3',
        validator: null,
        showNullSetter: false,
        mode: 'both',
        readonly: false,
    },
);

const emits = defineEmits<{
    (e: 'update:modelValue', val: ITimeSpan): void;
    (e: 'change', newval: ITimeSpan, oldval: ITimeSpan): void;
}>();

const updateModelValue = (val: ITimeSpan | null) => {
    if (val === null) {
        return;
    }

    emits('update:modelValue', val);
};

const change = (newval: ITimeSpan | null, oldval: ITimeSpan | null) => {
    if (newval === null || oldval === null) {
        return;
    }
    emits('change', newval, oldval);
};
</script>
